<template>
  <div class="results" ref="content">
    <ul class="list-inline d-md-flex d-xl-inline-flex mb-0 results-share">
      <li class="list-inline-item">
        <b-overlay :show="exporting" spinner-small variant="white">
          <a href="#" v-on:click.prevent="print"
            ><icon-base width="18" height="23" iconColor="#ff6000"
              ><icon-download
            /></icon-base>
            Download PDF</a
          >
        </b-overlay>
      </li>
      <li class="list-inline-item">
        <a v-on:click.prevent="retakeQuiz">Retake Quiz</a>
      </li>
    </ul>
    <template v-if="user.schoolKnown === 'yes' && user.majorKnown === 'yes'">
      <section class="results--unsure results--top">
        <div class="results__header">
          <h1 class="results__heading">Let’s look at your numbers.</h1>
          <p class="mb-0">
            Based on what you told us, your future may very well involve any
            of the following colleges, majors, and/or careers.
          </p>
        </div>
      </section>
      <section class="results--unsure results--tab">
        <div>
          <div align-h="center">
            <div xl="12" class="pb-0 text-center tadiv">
              <ul
                class="list-group list-group-flush flex-row justify-content-start justify-content-md-center"
              >
                <li
                  v-for="(majorCareer, i) in majorCareers"
                  v-bind:key="majorCareer.major"
                  :class="['list-group-item', { active: graphShown === i }]"
                  v-on:click="showGraph(i)"
                >
                  {{ majorCareer.major }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template
      v-else-if="
        user.careerKnown == 'yes' &&
          (user.schools.length > 0 || user.type !== 'unsure' || user.state)
      "
    >
      <section class="results--unsure results--top">
        <div>
          <div align-h="center">
            <div xl="7" class="results__header">
              <h1 class="results__heading">Let’s look at your numbers.</h1>
              <p class="mb-0">
                Based on what you told us, your future may look something like
                this.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section
        class="results--unsure results--tab"
        v-if="majorCareers.length > 1"
      >
        <div>
          <div align-h="center">
            <div xl="12" class="pb-0 text-center tadiv">
              <ul
                class="list-group list-group-flush flex-row justify-content-start justify-content-md-center"
              >
                <li
                  v-for="(majorCareer, i) in majorCareers"
                  v-bind:key="majorCareer.major"
                  :class="['list-group-item', { active: graphShown === i }]"
                  v-on:click="showGraph(i)"
                >
                  {{ majorCareer.major }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template v-else-if="user.type !== 'unsure' || user.state">
      <section class="results--unsure results--top">
        <div>
          <div align-h="center">
            <div xl="7" class="results__header">
              <h1 class="results__heading">Let’s look at your numbers.</h1>
              <p class="mb-0">
                Based on what you told us, your future may very well involve any
                of these majors.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="results--unsure results--tab">
        <div>
          <div align-h="center">
            <div xl="12" class="pb-0 text-center tadiv">
              <ul
                class="list-group list-group-flush flex-row justify-content-start justify-content-md-center"
              >
                <li
                  v-for="(majorCareer, i) in majorCareers"
                  v-bind:key="majorCareer.major"
                  :class="['list-group-item', { active: graphShown === i }]"
                  v-on:click="showGraph(i)"
                >
                  {{ majorCareer.major }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template
      v-if="user.type !== 'unsure' || user.state || user.schools.length > 0"
    >
      <section class="results--unsure results--dim">
        <div>
          <div
            v-for="(majorCareer, k) in majorCareers"
            v-bind:key="majorCareer.major"
            class="graph-content"
            :id="`graph-content-${k}`"
            v-show="graphShown === k"
          >
            <div ref="mySwiperRef" class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide align-items-stretch d-flex">
                  <div class="block">
                    <h2 class="text-center">
                      <icon-briefcase />Top careers and expected salaries with
                      this major.
                    </h2>
                    <table>
                      <thead>
                        <th><span>Top careers with this major</span></th>
                        <th align="right">
                          <div class="table__columnheader">
                            <span>Expected salary</span>
                            <icon-base
                              v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                expectedSalaryTooltip
                              "
                              tabindex="0"
                              ><icon-info
                            /></icon-base>
                          </div>
                        </th>
                      </thead>
                      <tr
                        v-for="career in majorCareer.careers"
                        v-bind:key="career.occ_code"
                      >
                        <td>
                          <strong>{{ career.occ_code }}</strong>
                        </td>
                        <td align="right">
                          <strong>{{ normalizeMoney(career.med_earn) }}</strong>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <template v-if="user.schools.length > 0">
                  <div
                    class="swiper-slide align-items-stretch d-flex"
                    v-for="school in user.schools"
                    v-bind:key="school.key"
                  >
                    <div class="block block--school">
                      <div class="block__header">
                        <h3 class="block__title">{{ school.INSTNM }}</h3>
                      </div>
                      <div class="bubble-pair">
                        <div cols="6" class="bubble-column">
                          <div class="bubble bubble-secondary">
                            <div class="bubble__content">
                              <small
                                >Expected annual <br /> cost of attendance <br /> (with aid) 
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    annualAttendanceTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info /></icon-base
                              ></small>
                              {{
                                normalizeMoney(
                                  school.NPT4_PUB || school.NPT4_PRIV
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div cols="6" class="bubble-column">
                          <div
                            class="bubble bubble-primary"
                            v-if="
                              hasEarningsOutcome(
                                school.UNITID,
                                majorCareer.major
                              )
                            "
                          >
                            <div class="bubble__content">
                              <small
                                >Median salary for this major at this school
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    medianSalaryMajorTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info /></icon-base
                              ></small>
                              {{
                                normalizeMoney(
                                  getOutcome(school.UNITID, majorCareer.major)[
                                    "MD_EARN_WNE"
                                  ]
                                )
                              }}
                            </div>
                          </div>
                          <div class="bubble bubble-primary" v-else>
                            <div class="bubble__content">
                              <small
                                >Median salary <br /> at this school
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    medianSalaryTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info /></icon-base
                              ></small>
                              {{ normalizeMoney(school.MD_EARN_WNE_P6) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="data-row mt-4">
                        <div lg="auto">
                          <p>Your federal loans snapshot</p>
                          <div class="data-cell no-gutters">
                            <div class="data-cell__column">
                              <p>
                                Expected median
                                <span class="text-nowrap"
                                  >federal loan debt</span
                                >
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    medianLoanDebtTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info
                                /></icon-base>
                              </p>
                              <h5>
                                {{ normalizeMoney(school.GRAD_DEBT_MDN) }}
                              </h5>
                            </div>
                            <div class="data-cell__column">
                              <p>
                                Monthly loan payment <br />
                                over 10 years
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    mlpMethod
                                  "
                                  tabindex="0"
                                  ><icon-info
                                /></icon-base>
                              </p>
                              <h5>
                                {{ normalizeMoney(school.GRAD_DEBT_MDN10YR)
                                }}<span v-if="school.GRAD_DEBT_MDN10YR"
                                  >/mo.</span
                                >
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="swiper-slide align-items-stretch d-flex">
                    <div class="block block--school">
                      <div class="block__header">
                        <h3 class="block__title">College costs breakdown</h3>
                      </div>
                      <div class="bubble-pair">
                        <div cols="6" class="bubble-column">
                          <div class="bubble bubble-secondary">
                            <div class="bubble__content">
                              <small
                                >Expected annual <br /> cost of attendance <br /> (with aid)
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    annualAttendanceTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info /></icon-base
                              ></small>
                              {{ normalizeMoney(averageTuition) }}
                            </div>
                          </div>
                        </div>
                        <div cols="6" class="bubble-column">
                          <div class="bubble bubble-primary">
                            <div class="bubble__content">
                              <small
                                >Median salary in <br /> this state
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    medianSalaryTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info /></icon-base
                              ></small>
                              {{ normalizeMoney(average["MD_EARN_WNE_P6"]) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="data-row">
                        <div lg="auto">
                          <p>Your federal loans snapshot</p>
                          <div class="data-cell no-gutters">
                            <div cols="6">
                              <p>
                                Expected median <br />
                                <span class="text-nowrap"
                                  >federal loan debt</span
                                >
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    medianLoanDebtTooltip
                                  "
                                  tabindex="0"
                                  ><icon-info
                                /></icon-base>
                              </p>
                              <h5>
                                {{ normalizeMoney(average["GRAD_DEBT_MDN"]) }}
                              </h5>
                            </div>
                            <div cols="6">
                              <p>
                                Monthly loan payment <br />over 10 years
                                <icon-base
                                  v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                    mlpMethod
                                  "
                                  tabindex="0"
                                  ><icon-info
                                /></icon-base>
                              </p>
                              <h5>
                                {{ normalizeMoney(average["GRAD_DEBT_MDN10YR"])
                                }}<span v-if="average['GRAD_DEBT_MDN10YR']"
                                  >/mo.</span
                                >
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="results__carousel-controls">
                <button
                  class="swiper-button-prev swiper-button-prev-majors"
                ></button>
                <div class="swiper-pagination"></div>
                <button
                  class="swiper-button-next swiper-button-next-majors"
                ></button>
              </div>
            </div>
          </div>
          <div align-h="center">
            <disclaimer />
          </div>
        </div>
      </section>
    </template>
    <template
      v-if="user.type === 'unsure' && !user.state && user.schools.length === 0"
    >
      <section class="results--unsure results--bubble">
        <div lg="7" class="results__header">
          <h1 class="results__heading">Let’s look at your numbers.</h1>
          <p>
            As you begin to explore your options, this might help you think
            about what kind of schools, majors, and careers you want to
            pursue.
          </p>
        </div>
        <div
          class="results__general-figures results__general-figures--1"
          v-scroll-reveal="{ delay: 350 }"
        >
          <div class="results__bubble-cluster">
            <div class="bubble bubble-secondary align-self-start">
              <small>Public school annual cost of attendance</small>
              $20,500
            </div>
            <div class="bubble bubble-primary align-self-end">
              <small>Private school annual cost of attendance</small>
              $52,590
            </div>
          </div>
          <div class="results__general-figures__copy">
            <h2>Public or private?</h2>
            <p>
              The cost to attend a private university tends to be higher than
              a public university. However, private universities may offer
              more financial aid to eligible students.
            </p>
            <a href="https://www.discover.com/student-loans/college-planning/how-to-pay/costs/average-cost-of-college-education" class="results__general-figures__cta">
              <span>
                Learn more about different type of schools <icon-base width="14" height="25"><icon-caret-right></icon-caret-right></icon-base>
              </span>
            </a>
            <small
              >Source: College Board
              <a
                href="https://research.collegeboard.org/media/pdf/trends-in-college-pricing-student-aid-2022.pdf"
                target="_blank"
                >Trends in College Pricing 2022</a
              >. Annual Survey of Colleges; NCES, IPEDS Fall 2020 Enrollment
              data.</small
            >
          </div>
        </div>
        <div
          class="results__general-figures results__general-figures--2"
          v-scroll-reveal="{ delay: 350 }"
        >
          <div class="results__bubble-cluster">
            <div class="bubble bubble-primary align-self-end">
              <small>Private nonprofit 4-year on-campus</small>
              $39,400
            </div>
            <div class="bubble bubble-secondary align-self-start">
              <small>Public 4-year <br />in-state on-campus</small>
              $10,940
            </div>
            <div
              class="bubble bubble-tertiary align-self-end align-self-md-center align-self-lg-center"
            >
              <small>Public 4-year out-of-state on-campus</small>
              $28,240
            </div>
          </div>
          <div class="results__general-figures__copy">
            <h2>In-state or out-of-state?</h2>
            <p>
              It is a common belief that out-of-state tuition can be more
              expensive than in-state tuition. As you evaluate college
              options, it’s important to look at costs beyond tuition.
            </p>
            <a href="https://www.discover.com/student-loans/college-planning/how-to-pay/costs/out-of-state-tuition" class="results__general-figures__cta">
              <span>
                Read about how location impact costs
                <icon-base width="14" height="25"><icon-caret-right></icon-caret-right></icon-base>
              </span>
              </a>
            <small
              ><strong>Source</strong>: College Board
              <a
                href="https://research.collegeboard.org/media/pdf/trends-in-college-pricing-student-aid-2022.pdf"
                target="_blank"
                >Trends in College Pricing 2022.</a
              >
              Annual Survey of Colleges; NCES, IPEDS Fall 2020 Enrollment
              data.</small
            >
          </div>
        </div>
      </section>
      <section class="results--unsure results--blocks">
        <div>
          <div align-h="center">
            <div
              lg="7"
              class="pt-4 pb-4 pt-lg-6 pb-lg-5 pt-xl-5 pb-xl-5 pb-md-5 pt-md-5 text-center header"
            >
              <h1 class="mb-0">A look at some majors you might like.</h1>
            </div>
          </div>
          <div align-h="center" class="align-items-stretch mb-3 mb-lg-5">
            <div ref="majorCarousel" class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="majorCareer in majorCareers"
                  v-bind:key="majorCareer.major"
                  class="swiper-slide mb-2 mb-md-0 d-flex"
                >
                  <div class="block">
                    <h2><icon-briefcase />{{ majorCareer.major }}</h2>
                    <table>
                      <thead>
                        <th><span>Top careers with this major</span></th>
                        <th align="right">
                          <span>
                            <span>Expected salary</span>
                              <icon-base
                                v-b-tooltip:discover-kettle-college-tool.hover.top.html.v-light="
                                  expectedSalaryTooltip
                                "
                                tabindex="0"
                                ><icon-info
                              /></icon-base>
                          </span>
                        </th>
                      </thead>
                      <tr
                        v-for="career in majorCareer.careers"
                        v-bind:key="career.occ_code"
                      >
                        <td>
                          <strong>{{ career.occ_code }}</strong>
                        </td>
                        <td align="right">
                          <strong>{{ normalizeMoney(career.med_earn) }}</strong>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="results__carousel-controls">
                <div class="swiper-button-prev swiper-button-prev-majors"></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next swiper-button-next-majors"></div>
              </div>
            </div>
          </div>
          <div align-h="center">
            <disclaimer />
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
// import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper, { Navigation, Pagination } from "swiper";
import IconBase from "./IconBase.vue";
import IconInfo from "./icons/IconInfo.vue";
import IconDownload from "./icons/IconDownload.vue";
import IconCaretRight from './icons/IconCaretRight.vue'
import IconBriefcase from "./animatedicons/IconBriefcase.vue";
import Disclaimer from "./Disclaimer.vue";
import { builder as buildPdf } from "@/tools/pdf";

import VueScrollReveal from "vue-scroll-reveal";
import VueScrollTo from "vue-scrollto";
import Vue from "vue";

Vue.use(VueScrollTo);
Vue.use(VueScrollReveal, {
  class: "is-visible",
  distance: "20px"
});

// Map degree names to DOE codes used in salary outcomes
import states from "./../data/states.json";
import degreeCodes from "./../data/degree-codes.json";

const degreeToCodeMap = {};
degreeCodes.forEach(dc => {
  degreeToCodeMap[dc.degree] = dc.code;
});

// Map skill names to degree names
import skills from "./../data/skills.json";

const skillToDegreesMap = {};
skills.forEach(sd => {
  const skill = sd.skill.trim();
  const degree = sd.degree.trim();

  if (!skillToDegreesMap[skill]) {
    skillToDegreesMap[skill] = [degree];
  } else {
    skillToDegreesMap[skill].push(degree);
  }
});

const averageOutcomeCache = {};

export default {
  name: "Results",
  props: {
    user: Object,
    lists: Object
  },
  data() {
    return {
      exporting: false,
      graphShown: 0,
      output: null
    };
  },
  components: {
    IconBase,
    IconInfo,
    IconDownload,
    IconBriefcase,
    Disclaimer,
    IconCaretRight,
  },
  mounted: function() {
    this.handleMediaQueries();

    // show first tab
    this.showGraph(0);
  },
  beforeUnmount() {
    this.destroySwipers();
    this.cleanupMediaQueries();
  },
  methods: {
    getStateAbbreviation() {
      return states.find(({ name }) => name ===  this.user.state)?.abbreviation
    },
    retakeQuiz: function() {
      location.reload();
    },
    initializeSwipers() {
      [
        this.$refs.majorCarousel,
        this.$refs.mySwiperRef ? this.$refs.mySwiperRef[this.graphShown] : null
      ]
        .filter(Boolean)
        .forEach(element => this.createSwiperForElement(element));
    },
    createSwiperForElement(element) {
      if (element) {
        if (!element.swiper) {
          element.swiper = new Swiper(element, this.getSwiperOptions());
        }

        if (!this.mobileMedia?.matches) {
          element.swiper.init();
        }
      }
    },
    destroySwipers() {
      [
        this.$refs.articleCarousel?.swiper,
        this.$refs.majorCarousel?.swiper,
        ...(this.$refs.mySwiperRef
          ? this.$refs.mySwiperRef.map(({ swiper }) => swiper)
          : [])
      ].forEach(swiper => {
        swiper?.destroy();
      });
    },
    handleMediaQueries() {
      this.mobileMedia =
        this.mobileMedia || window.matchMedia(`screen and (max-width: 767px)`);

      this.mobileMedia.addEventListener(
        "change",
        this.onMobileBreakpoint.bind(this)
      );
    },
    cleanupMediaQueries() {
      this.mobileMedia.removeEventListener(
        "change",
        this.onMobileBreakpoint.bind(this)
      );
    },
    onMobileBreakpoint(mediaQuery) {
      if (mediaQuery.matches) {
        this.destroySwipers();
      } else {
        this.initializeSwipers();
      }
    },
    getSwiperOptions: function() {
      return {
        modules: [Navigation, Pagination],
        watchOverflow: true,
        slidesPerView: window.innerWidth >= 992 ? 2 : 1,
        spaceBetween: 20,
        simulateTouch: false,
        init: false,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next"
        },
        pagination: {
          el: ".swiper-pagination",
          bulletElement: "button",
          clickable: true
        },
        breakpoints: {
          0: {
            enabled: false
          },
          768: {
            slidesPerView: 1.5
          },
          992: {
            slidesPerView: 2
          }
        },
        on: {
          init: function() {
            setTimeout(
              function() {
                if (
                  window.innerWidth < 450 &&
                  !this.$el[0].classList.contains("article-carousel")
                ) {
                  this.destroy(false, true);
                } else {
                  var wrapper = this.$wrapperEl[0];

                  if (this.snapGrid.length > 1) {
                    wrapper.className = "swiper-wrapper start";
                  }
                }
              }.bind(this),
              0
            );
          },
          lock: function() {
            this.el.classList.add("swiper-container--locked");
          },
          unlock: function() {
            this.el.classList.remove("swiper-container--locked");
          }
        }
      };
    },
    next: function(el) {
      el.$swiper.slideNext();
    },
    prev: function(el) {
      el.$swiper.slidePrev();
    },
    mlpMethod: function() {
      return `<p>Estimated Monthly Loan Payment is calculated using a fixed interest rate of 4.99% for undergraduate Direct Subsidized and Unsubsidized Loans and a standard 10-year repayment plan (principal and interest payments). Source: US Department of Education College Scorecard (2023).</p>
          <p>Median refers to the middle number (or the average of two middle numbers) in a sorted list.</p>`;
    },
    expectedSalaryTooltip: function() {
      return `<p>Salary information is based on people aged 25-29 who have graduated with at least a bachelor's degree and have worked full-time for at least one year during the timeframe of January 2017 through December 2021.</p>
              <p>Source: US Census American Community Survey (2021)</p>`;
    },
    annualAttendanceTooltip: function() {
      return `<p>The average annual cost is the average net price for students who receive federal financial aid (e.g., Pell grants, federal loans) for one academic year of study. Net price is calculated by adding the advertised price for tuition, fees, books, supplies, and the average living costs at the school (on-campus, off-campus not with family, and off-campus with family) and subtracting the average grant and/or scholarship aid (e.g., Pell grants, school-based grants, merit scholarships). Net price is calculated as the average overall full-time, first-time students who receive federal financial aid and may not reflect a specific student's annual costs. For public schools, this is only the average cost for in-state students.</p>
              <p>Source: US Department of Education College Scorecard (2023)</p>`;
    },
    medianSalaryTooltip: function() {
      return `<p>Median Salary is the salary for students at user-selected schools who enrolled as freshmen in 2012-2013, received federal financial aid, and reported earnings from full-time or part-time employment in 2019-2020. Earnings are based on the sum of wages and deferred compensation from W-2 forms and have been adjusted to reflect inflation as of 2021. Source: US Department of Education College Scorecard (2023).</p>
              <p>Median refers to the middle number (or the average of two middle numbers) in a sorted list.</p>`;
    },
    medianSalaryMajorTooltip: function() {
      return `<p>Median Salary is the one-year salary for students at the same college and in the same major who received federal financial aid and graduated between July 2016 and June 2018. Source: US Department of Education College Scorecard (2023).</p>
              <p>Median refers to the middle number (or the average of two middle numbers) in a sorted list.</p>`;
    },
    medianLoanDebtTooltip: function() {
      return `<p>Median Federal Loan Debt includes the cumulative federal loan debt of student borrowers at the same college and who graduated between October 2019 and September 2021. Source: US Department of Education College Scorecard (2023).</p>
          <p>Median refers to the middle number (or the average of two middle numbers) in a sorted list.</p>`;
    },
    /*
     * Get outcome data for school, degree
     *
     * @param number unitid School ID (`UNITID`)
     * @param number cipcode DOE Degree ID (`CIPCODE`)
     * @return object
     */
    getOutcome: function(unitid, cipcode) {
      if (typeof cipcode === "string") {
        cipcode = degreeToCodeMap[cipcode.toUpperCase()];
      }

      const school = this.lists.outcomes[unitid];
      if (typeof school === "undefined") {
        console.warn("Could not find school UNITID #%d in outcomes", unitid);
        return {
          DEBTMEDIAN: 0,
          DEBTPAYMENT10YR: 0,
          MD_EARN_WNE: 0
        };
      }

      const outcome = school[cipcode];
      if (typeof outcome === "undefined") {
        return {
          DEBTMEDIAN: 0,
          DEBTPAYMENT10YR: 0,
          MD_EARN_WNE: 0
        };
      }
      return outcome;
    },
    /*
     * Check if earnings outcome data for school, degree exists
     *
     * @param number unitid School ID (`UNITID`)
     * @param number cipcode DOE Degree ID (`CIPCODE`)
     * @return bool
     */
    hasEarningsOutcome: function(unitid, cipcode) {
      if (typeof cipcode === "string") {
        cipcode = degreeToCodeMap[cipcode.toUpperCase()];
      }

      const outcome = this.lists.outcomes[unitid][cipcode];
      if (typeof outcome === "undefined") {
        return false;
      }
      return outcome["MD_EARN_WNE"] >= 1;
    },
    /*
     * Average outcome (given school type, in-state, state)
     *
     * @param number cipcode DOE Degree ID (`CIPCODE`)
     * @return object
     */
    averageOutcome: function(cipcode) {
      const state = this.getStateAbbreviation();

      // Memoize
      if (averageOutcomeCache[cipcode]) {
        return averageOutcomeCache[cipcode];
      }

      if (typeof cipcode === "string") {
        cipcode = degreeToCodeMap[cipcode.toUpperCase()];
      }

      const sums = {
        DEBTMEDIAN: 0,
        DEBTPAYMENT10YR: 0,
        MD_EARN_WNE: 0
      };
      const counts = {
        DEBTMEDIAN: 0,
        DEBTPAYMENT10YR: 0,
        MD_EARN_WNE: 0
      };

      this.lists.schools.forEach(school => {
        // Skip over schools not of the user's preferred type
        if (this.user.type === "public") {
          if (school.CONTROL !== 1) {
            return;
          }
        } else if (this.user.type === "private") {
          if (school.CONTROL === 1) {
            return;
          }
        }

        // Skip over schools not in the user's selected state
        if (state) {
          if (state != school.STABBR) {
            return;
          }
        }

        const outcome = this.getOutcome(school.UNITID, cipcode);
        if (outcome["DEBTMEDIAN"] !== 0) {
          sums["DEBTMEDIAN"] += outcome["DEBTMEDIAN"];
          counts["DEBTMEDIAN"]++;
        }
        if (outcome["DEBTPAYMENT10YR"] !== 0) {
          sums["DEBTPAYMENT10YR"] += outcome["DEBTPAYMENT10YR"];
          counts["DEBTPAYMENT10YR"]++;
        }
        if (outcome["MD_EARN_WNE"] !== 0) {
          sums["MD_EARN_WNE"] += outcome["MD_EARN_WNE"];
          counts["MD_EARN_WNE"]++;
        }
      });

      return {
        DEBTMEDIAN: counts["DEBTMEDIAN"]
          ? Math.ceil(sums["DEBTMEDIAN"] / counts["DEBTMEDIAN"])
          : 0,
        DEBTPAYMENT10YR: counts["DEBTPAYMENT10YR"]
          ? Math.ceil(sums["DEBTPAYMENT10YR"] / counts["DEBTPAYMENT10YR"])
          : 0,
        MD_EARN_WNE: counts["MD_EARN_WNE"]
          ? Math.ceil(sums["MD_EARN_WNE"] / counts["MD_EARN_WNE"])
          : 0
      };
    },
    /*
     * Round, add thousands separator, prepend `$`
     *
     * @param number val
     * @return string
     */
    normalizeMoney: function(val) {
      if (val === 0 || val === null) {
        return "N/A";
      }
      const digits = Math.ceil(val)
        .toString()
        .split("");
      let i = 0;
      let s = "";

      // Add thousand separator
      let digit = digits.pop();
      while (typeof digit !== "undefined") {
        if (i !== 0 && i % 3 === 0) {
          s = "," + s;
        }

        s = digit + s;
        i += 1;

        digit = digits.pop();
      }

      return "$" + s;
    },
    showGraph: function(num) {
      this.graphShown = num;
      this.initializeSwipers();
    },
    showShare: function(e) {
      e.preventDefault();
      this.shareShown = !this.shareShown;
    },
    buildPdf,
    print: async function(e) {
      e.preventDefault();

      if (window.s) {
        window.s.linkTrackVars = "prop1";
        window.s.prop1 = "MCP_DownloadPDF";
        window.s.tl(this, "o", "MCP_DownloadPDF");
      }

      const pdf = await this.buildPdf();
      pdf.download("Your-college-cost-guide.pdf");
    }
  },
  computed: {
    /*
     * Name of state the user previously selected
     *
     * @return string
     */
    stateName: function() {
      const state = states.find(r => r.abbreviation === this.user.state);
      return state ? state.name : null;
    },
    /*
     * Get mapping of majors to likely careers based on user's selections
     *
     * @return object
     */
    majorCareers: function() {
      let majors;

      if (this.user.majors.length > 0) {
        majors = this.user.majors;
      } else if (this.user.occupation) {
        majors = [
          this.lists.degreesByCareer.get(this.user.occupation)[0].degfieldd
        ];
      } else if (this.user.skills.length) {
        majors = skillToDegreesMap[this.user.skills[0]];
      } else {
        throw new Error(
          "User selected neither major nor occupation nor skills"
        );
      }

      const majorCareers = [];

      if (majors.length) {
        majors.forEach(major => {
          const careers = this.lists.careersByDegree.get(major);

          majorCareers.push({
            major: major,
            careers: careers.slice(0, 3)
          });
        });
      }

      return majorCareers;
    },
    /*
     * Average data points (given school type, in-state, state) over four years
     *
     * @return number
     */
    average: function() {
      const state = this.getStateAbbreviation();

      let sums = {
        GRAD_DEBT_MDN: 0,
        GRAD_DEBT_MDN10YR: 0,
        MD_EARN_WNE_P6: 0
      };
      let counts = {
        GRAD_DEBT_MDN: 0,
        GRAD_DEBT_MDN10YR: 0,
        MD_EARN_WNE_P6: 0
      };

      this.lists.schools.forEach(school => {
        // Skip over schools not of the user's preferred type
        if (this.user.type === "public") {
          if (school.CONTROL !== 1) {
            return;
          }
        } else if (this.user.type === "private") {
          if (school.CONTROL === 1) {
            return;
          }
        }

        // Skip over schools not in the user's selected state
        if (state) {
          if (state != school.STABBR) {
            return;
          }
        }

        if (school.GRAD_DEBT_MDN) {
          sums["GRAD_DEBT_MDN"] += school.GRAD_DEBT_MDN;
          counts["GRAD_DEBT_MDN"] += 1;
        }

        if (school.GRAD_DEBT_MDN10YR) {
          sums["GRAD_DEBT_MDN10YR"] += school.GRAD_DEBT_MDN10YR;
          counts["GRAD_DEBT_MDN10YR"] += 1;
        }

        if (school.MD_EARN_WNE_P6) {
          sums["MD_EARN_WNE_P6"] += school.MD_EARN_WNE_P6;
          counts["MD_EARN_WNE_P6"] += 1;
        }
      });

      return {
        GRAD_DEBT_MDN: counts["GRAD_DEBT_MDN"]
          ? Math.ceil(sums["GRAD_DEBT_MDN"] / counts["GRAD_DEBT_MDN"])
          : 0,
        GRAD_DEBT_MDN10YR: counts["GRAD_DEBT_MDN10YR"]
          ? Math.ceil(sums["GRAD_DEBT_MDN10YR"] / counts["GRAD_DEBT_MDN10YR"])
          : 0,
        MD_EARN_WNE_P6: counts["MD_EARN_WNE_P6"]
          ? Math.ceil(sums["MD_EARN_WNE_P6"] / counts["MD_EARN_WNE_P6"])
          : 0
      };
    },
    /*
     * Average tuition (given school type, in-state, state) over four years
     *
     * @return number
     */
    averageTuition: function() {
      const state = this.getStateAbbreviation();
      let tuitionSum = 0;
      let schoolCount = 0;

      this.lists.schools.forEach(school => {
        let tuition = school.NPT4_PUB || school.NPT4_PRIV;

        // Skip over schools not of the user's preferred type
        if (this.user.type === "public") {
          if (school.CONTROL !== 1) {
            return;
          }
        } else if (this.user.type === "private") {
          if (school.CONTROL === 1) {
            return;
          }
        }

        // Skip over schools not in the user's selected state
        if (state) {
          if (state != school.STABBR) {
            return;
          }
        }

        schoolCount += 1;
        tuitionSum += tuition;
      });

      if (schoolCount === 0) {
        return 0;
      }

      return Math.ceil(tuitionSum / schoolCount);
    }
  }
};
</script>

<style scoped></style>
